export const decimalFractionDigits = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

/**
 * @param {number} value - The target value used to be formatted.
 * @param {Intl.NumberFormatOptions} [config] - The configuration to customize
 * the formatting.
 * @param {boolean} [displayFreeLabel] - A boolean flag used to enable the
 * function to return a "Gratis" string when the provided value is zero.
 * NOTE: This flag may be removed in the future if we decide that this behavior
 * should happen everywhere on the system.
 * @returns {string} The number formatted for the italian currency (euro).
 */
export function formatCurrency(
  value: number,
  config?: Intl.NumberFormatOptions,
  displayFreeLabel?: boolean,
) {
  if (displayFreeLabel && value === 0) return 'Gratis';

  return Intl.NumberFormat('it', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...config,
  }).format(value);
}

export const priceCurrency = {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
};
